/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Classification_Agent_AssistedInputs */

const en_directory_agent_readiness_classification_agent_assisted = /** @type {(inputs: Directory_Agent_Readiness_Classification_Agent_AssistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent assisted`)
};

const zh_directory_agent_readiness_classification_agent_assisted = /** @type {(inputs: Directory_Agent_Readiness_Classification_Agent_AssistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 辅助`)
};

/**
* | output |
* | --- |
* | "Agent assisted" |
*
* @param {Directory_Agent_Readiness_Classification_Agent_AssistedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_classification_agent_assisted = /** @type {((inputs?: Directory_Agent_Readiness_Classification_Agent_AssistedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Classification_Agent_AssistedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_classification_agent_assisted(inputs)
	return zh_directory_agent_readiness_classification_agent_assisted(inputs)
});
export { directory_agent_readiness_classification_agent_assisted as "directory.agent_readiness.classification.agent_assisted" }